<template>
  <div
    class="flex items-center justify-start px-[12px] sticky -left-[1px]"
    :class="className"
  >
    <b-form-checkbox
      v-model="model"
      :disabled="checkboxDisabled"
      @change="handleCheckboxChange"
      @click.native.stop
    />
  </div>
</template>

<script>
export default {
  name: 'CollapseHeaderCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: '',
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    checkboxDisabled() {
      const { status } = this.$route.query
      if (!status) {
        return false
      }
      return (status !== 'submitted' && status !== 'confirmed')
    },
  },
  methods: {
    handleCheckboxChange() {
      this.$emit('change', this.model)
    },
  },
}
</script>
